import { DateField, TradeCompanySiteAutocomplete, TradeCompanySiteSelector, useWatch } from 'form';
import { useTranslation } from 'i18n';
import { SectionContainer } from 'ui';

import type { CreateFormValues } from '../../pages/PurchaseOrderCreate/PurchaseOrderCreate';
import { IncotermSpecificFields } from '../IncotermSpecificFields/IncotermSpecificFields';
import { TransportMethod } from '../TransportMethod/TransportMethod';

export const SellerLogisticsSection = () => {
  const { t } = useTranslation('orders');
  const { seller_id, producer_id, incoterm } = useWatch<CreateFormValues>();

  return (
    <SectionContainer title={t('sellerLogisticsSection.title')}>
      <TradeCompanySiteSelector
        name="production_site_id"
        label={t('sellerLogisticsSection.labels.productionSite')}
        tradeCompanyId={producer_id}
        disabled={true}
        required
        infoTooltip={t('sellerLogisticsSection.tooltips.productionSite')}
      />
      <TradeCompanySiteAutocomplete
        name="collection_site_id"
        label={t('buyerLogisticsSection.labels.collectionSite')}
        tradeCompanies={[seller_id, producer_id].filter((value) => value !== null && value !== undefined)}
        required
        infoTooltip={t('buyerLogisticsSection.tooltips.collectionSite')}
      />
      <DateField
        name="target_collection_date"
        label={t('sellerLogisticsSection.labels.targetCollectionDate')}
        required
        infoTooltip={t('sellerLogisticsSection.tooltips.targetCollectionDate')}
        fullWidth
      />
      <TransportMethod required />
      <IncotermSpecificFields incoterm={incoterm} />
    </SectionContainer>
  );
};
